import { useMemo } from "react";
import Store from "logic/local-storage/Store";
import useQuery from "routing/useQuery";
const useEventDefinitionConfigFromLocalStorage = () => {
  const { "session-id": sessionId } = useQuery();
  return useMemo(() => {
    const parsedLocalStorageConfig = Store.get(sessionId);
    if (!parsedLocalStorageConfig) return { hasLocalStorageConfig: false, configFromLocalStorage: void 0 };
    Store.delete(sessionId);
    const {
      type,
      query,
      streams,
      search_within_ms,
      group_by,
      agg_function,
      agg_field,
      agg_value,
      loc_query_parameters
    } = parsedLocalStorageConfig;
    const aggData = agg_function && agg_value ? {
      conditions: {
        expression: {
          expr: void 0,
          left: { expr: "number-ref", ref: `${agg_function}-${agg_field}` },
          right: { expr: "number", value: agg_value }
        }
      },
      series: [{ id: `${agg_function}-${agg_field}`, function: agg_function, field: agg_field }],
      group_by: group_by || []
    } : {};
    return {
      hasLocalStorageConfig: true,
      configFromLocalStorage: {
        type,
        query: query != null ? query : "",
        streams: streams != null ? streams : [],
        search_within_ms,
        group_by: group_by != null ? group_by : [],
        query_parameters: loc_query_parameters != null ? loc_query_parameters : [],
        ...aggData
      }
    };
  }, [sessionId]);
};
export default useEventDefinitionConfigFromLocalStorage;
